import { useUnit } from "effector-react";
import { UserData } from "..//components/UserData";
import { $userData } from "../store/userData";

export const UserProfile = () => {
    const userData = useUnit($userData);

    return (
        <div>
            <UserData key={userData.id} data={userData} />
        </div>
    );

};